'use es6';

import { OrderedSet, Set as ImmutableSet } from 'immutable';
import uniqueId from 'transmute/uniqueId';
import RecordFactory from '../RecordFactory';
import { AdWordsStatusMap } from '../../lib/Constants';
import AdWordsBiddingStrategyConfigurationEntityRecord from './AdWordsBiddingStrategyConfigurationEntityRecord'; //https://git.hubteam.com/HubSpot/Ads/blob/master/AdsData/src/main/java/com/hubspot/ads/data/adwords/AbstractAdGroupView.java

export default RecordFactory({
  id: null,
  name: '',
  status: AdWordsStatusMap.ENABLED,
  campaignId: null,
  trackingUrlTemplate: null,
  maxCpc: null,
  targetCpa: null,
  targetRoas: null,
  keywords: OrderedSet(),
  textAds: OrderedSet(),
  templateAds: OrderedSet(),
  biddingStrategyConfiguration: new AdWordsBiddingStrategyConfigurationEntityRecord({}),
  partitions: ImmutableSet() // only for shopping campaigns

}, () => {
  return {
    id: `${uniqueId() * -1}`
  };
});